module.exports = __webpack_public_path__ + "img/22.e7694fac.jpg";